import React, { Component } from 'react'
import { connect } from 'react-redux'
import { delay } from 'utils'
import { isURL } from 'validator'

import * as R from 'ramda'

import { editAccount, newAccount } from 'api/accounts'

import { A, Button, Footer, Input, P, Section, Sidebar } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { showTransientNotification } from '@driftt/traffic-control'

import './style.css'

class CreateOrEditAccountSidebar extends Component {
  constructor(props) {
    super(props)
    const { accountProfile } = props

    this.state = {
      domain: accountProfile ? accountProfile.domain : '',
      name: accountProfile ? accountProfile.name : '',
      ownerId: accountProfile ? accountProfile.ownerId : null,
      saving: false,
    }
  }

  isValid = () => isURL(this.state.domain) && this.state.name && this.state.ownerId

  saveAccount = () => this.setState({ saving: true }, this.sendAccount)

  sendAccount = async () => {
    const { accountProfile, close, fetchAccounts, onSendAccountFailure, onSendAccountSuccess } = this.props
    const { domain, name, ownerId } = this.state
    const account = { domain, name, ownerId }

    try {
      let msg

      if (accountProfile) {
        editAccount({ accountId: accountProfile.accountId, ...account })
        msg = 'Successfully updated account'
      } else {
        newAccount(account)
        msg = 'Successfully created account'
      }

      this.setState(
        {
          saving: false,
        },
        async () => {
          onSendAccountSuccess(msg)
          close()
          await delay(fetchAccounts, 1000) // to give the backend enough time to update
        }
      )
    } catch (err) {
      console.log(err)
      onSendAccountFailure()
    }
  }

  render() {
    const { accountProfile, close, open } = this.props
    const { domain, name, ownerId, saving } = this.state

    const SIDEBAR_HEADER = accountProfile ? 'Edit account' : 'Create new account'

    const accountOwnerOptions = this.props.accountOwners.map(owner => ({
      label: owner.name || owner.email,
      value: owner.id,
    }))

    return (
      <Sidebar className="accounts-new-account-sidebar" close={close} title={SIDEBAR_HEADER} hideOverlay isOpen={open}>
        <Section>
          <Input
            description="Name of the account (e.g. Drift)"
            label="Account name"
            onChange={({ target }) => this.setState({ name: target.value })}
            type="text"
            value={name}
          />
          <Input
            description="Domain of the account (e.g. www.drift.com)"
            label="Account domain"
            onChange={({ target }) => this.setState({ domain: target.value })}
            type="url"
            value={domain}
          />
          <Select
            className="new-account-modal-owner-select"
            description="Owner of the account"
            label="Account owner"
            onChange={option => this.setState({ ownerId: option ? option.value : null })}
            options={accountOwnerOptions}
            value={R.find(R.propEq('value', ownerId), accountOwnerOptions)}
          />
          <P className="accounts-new-account-privacy-policy">
            Drift respects privacy rights and data protection laws. You may only share other people's personal
            information with Drift, whether directly or through third-party integrations, if you are permitted
            to do so under applicable law.{' '}
            <A href="https://www.drift.com/privacy-policy/" rel="noopener noreferrer" target="_blank">
              View our Privacy Policy
            </A>
            .
          </P>
        </Section>
        <Footer>
          <Button disabled={saving || !this.isValid()} onClick={this.saveAccount} type="primary">
            Save account
          </Button>
        </Footer>
      </Sidebar>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  onSendAccountSuccess: message =>
    dispatch(
      showTransientNotification({
        message,
        type: 'success',
      })
    ),
  onSendAccountFailure: () =>
    dispatch(
      showTransientNotification({
        message: 'We could not save your account',
        type: 'error',
      })
    ),
})

export default connect(
  null,
  mapDispatchToProps
)(CreateOrEditAccountSidebar)
